import {
  IReimbursementCategoryServiceResponse,
  IReimbursementServiceResponse,
} from "../../../features/reimbursement/types";
import { IBaseResponse } from "../../../Types/UserProfileDetails";
import ApiService from "../../ApiService";

enum ReimbursementEndpoints {
  REIMBURSEMENT_FORM = "/employee/reimbursement",
  REIMBURSEMENT_CATEGORIES = "/employee/reimbursement/categories",
  REIMBURSEMENT_DELETE = "/employee/reimbursement/delete",
}

export interface IDeleteReimbursement extends IBaseResponse {
  data: {
    deleted_id: number;
  };
}

class ReimbursementService extends ApiService {
  async reimbursementList(userId?: number) {
    const query = userId ? `?userId=${userId}` : "";
    return this.get<IReimbursementServiceResponse>(
      `${ReimbursementEndpoints.REIMBURSEMENT_FORM}${query}`
    );
  }

  async reimbursementCategoryList() {
    return this.get<IReimbursementCategoryServiceResponse>(
      ReimbursementEndpoints.REIMBURSEMENT_CATEGORIES
    );
  }

  async reimbursementBillView(filePath: string) {
    const uthoService = new ApiService(
      `${process.env.REACT_APP_UTHO_BUCKET_URL}?path=${filePath}`,
      undefined,
      process.env.REACT_APP_UTHO_API_KEY
    );
    return uthoService.get<{ status: string; url: string }>();
  }

  async submitReimbursementForm(reimbursementFormData: FormData) {
    return this.post<IBaseResponse>(
      ReimbursementEndpoints.REIMBURSEMENT_FORM,
      reimbursementFormData
    );
  }

  async deleteReImbursement(reimbursementData: { id: number }) {
    return this.post<IDeleteReimbursement>(
      ReimbursementEndpoints.REIMBURSEMENT_DELETE,
      reimbursementData
    );
  }
}

export const reimbursementService = new ReimbursementService();
